import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "as-league_title" }
const _hoisted_2 = ["src", "alt"]

import { onMounted, onUnmounted, ref, reactive, computed } from "vue";
import SvgSprite from "~src/components/matches/SvgSprite.vue";
import MatchItem from "~src/modules/schedule/components/MatchItem.vue";
import type { ICompetitions, IFilterResult, IMatch, IMatchLiveData, IMatchLiveDict } from "~src/interfaces";
import PopupLinkStream from "~src/modules/schedule/components/PopupLinkStream.vue";


const __default__ = {};

interface IProps {
  competitions: ICompetitions[];
  filter: IFilterResult;
  isLoadMoreInverse: boolean;
  isLoadInverse: boolean;
  matchLives: IMatchLiveData
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'MatcheList',
  props: {
    competitions: {},
    filter: {},
    isLoadMoreInverse: { type: Boolean },
    isLoadInverse: { type: Boolean },
    matchLives: {}
  },
  emits: ["loadInverse"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;
const page = ref(1);
const isLoadMore = ref(false);
const competitionEnd = ref(0);
const scrollComponent = ref<HTMLElement | null>(null);
const leagues = ref<Array<ICompetitions>>([]);

const isShowPopupLinkStream = ref(false);
const matchLinkStream = ref<IMatch | null>(null);

onMounted(() => {
  loadMoreLeagues();
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const getLeagues = () => {
  const limit = 50;
  const offset = page.value * limit;

  let count = 0;
  let datas: Array<ICompetitions> = [];
  const __matchLives = props.matchLives.matches || []
  props.competitions.forEach((competition: ICompetitions, index: any) => {
    if (
      (competitionEnd.value === 0 || competitionEnd.value < index) &&
      count < offset
    ) {
      competition = updateCompetitionWithMatchLives(competition, __matchLives)
      datas.push(competition);
      if (competitionEnd.value < index) {
        competitionEnd.value = index;
      }
      count += competition.matchs.length;
    }
  });

  return datas;
};

const loadMoreLeagues = () => {
  if (
    isLoadMore.value &&
    props.competitions.length - 1 === competitionEnd.value
  ) {
    return;
  }
  isLoadMore.value = true;
  page.value = page.value + 1;
  let newleagues = getLeagues();
  leagues.value.push(...newleagues);
};

const handleScroll = (e: any) => {
  let element = scrollComponent.value;
  if (
    element &&
    element.getBoundingClientRect().bottom < window.window.innerHeight + 300
  ) {
    loadMoreLeagues();
  }

  // if (!props.isLoadMoreInverse && props.isLoadInverse && props.filter.tag) {
  //   let element = scrollComponent.value;
  //   if (
  //     element &&
  //     element.getBoundingClientRect().bottom <= window.innerHeight + 600
  //   ) {
  //     emits("loadInverse", true);
  //   }
  // }
};

const handleItemClicked = (match: IMatch, flag: boolean) => {
  matchLinkStream.value = match;
  isShowPopupLinkStream.value = flag;
};

const updateCompetitionWithMatchLives = (competition: ICompetitions, matchLives: IMatch[]) => {
    const matchLiveDict = matchLives.reduce<IMatchLiveDict>((acc, match: IMatch) => {
        acc[match.id] = match;
        return acc;
    }, {});

    competition.matchs = competition.matchs.map(match => ({
        ...match,
        match_live_item: matchLiveDict[match.id] || null
    }));

    return competition;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SvgSprite),
    _createElementVNode("div", {
      class: "as-matches",
      ref_key: "scrollComponent",
      ref: scrollComponent
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leagues.value, (competition) => {
        return (_openBlock(), _createElementBlock("div", {
          key: competition.id,
          class: _normalizeClass(`as-competition-wrapper as-competition-wrapper-${_ctx.gSiteName}`)
        }, [
          _createElementVNode("div", _hoisted_1, [
            (competition.isShowLogo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "as-lazyload",
                  src: _ctx.getImgUrlBySport('competition', competition.id),
                  alt: competition.title
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(competition.title), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(competition.matchs, (match) => {
            return (_openBlock(), _createBlock(MatchItem, {
              key: match.id,
              match: match,
              competitionType: competition.type,
              onItemClicked: handleItemClicked
            }, null, 8, ["match", "competitionType"]))
          }), 128))
        ], 2))
      }), 128))
    ], 512),
    _createVNode(PopupLinkStream, {
      isShowPopup: isShowPopupLinkStream.value,
      match: matchLinkStream.value,
      sites: _ctx.matchLives?.sites || [],
      onToggle: _cache[0] || (_cache[0] = ($event: any) => (isShowPopupLinkStream.value = !isShowPopupLinkStream.value))
    }, null, 8, ["isShowPopup", "match", "sites"])
  ], 64))
}
}

})